/**
 * Redux actions for membership management.
 *
 * Each action describes an API call to be run by Volto's api middleware.
 * The middleware appends _PENDING, _SUCCESS, or _FAIL to the action type
 * and dispatches the resulting action with result or error attached.
 * @module actions/membership
 */

import {
  IDP_GET_MEMBERSHIP,
  IDP_MEMBERSHIP_ACTION,
  IDP_MEMBERSHIP_DOWNLOAD,
} from '../constants/ActionTypes';

/**
 * Fetch membership overview: stats, downloads, actions.
 *
 * @returns Action for Volto's api middleware.
 */
export function getMembership() {
  return {
    type: IDP_GET_MEMBERSHIP,
    request: {
      op: 'get',
      path: '/@membership',
    },
  };
}

/**
 * Run a membership action (open/close/remind renewal cycle).
 *
 * @param actionId The action identifier (e.g., 'open-renewal-cycle').
 * @returns Action for Volto's api middleware.
 */
export function runMembershipAction(actionId: string) {
  return {
    type: IDP_MEMBERSHIP_ACTION,
    request: {
      op: 'post',
      path: `/@membership/${actionId}`,
    },
  };
}

/**
 * Fetch membership download (e.g., voters list).
 *
 * @param downloadId The download identifier (e.g., 'voters').
 * @returns Action for Volto's api middleware.
 */
export function getMembershipDownload(downloadId: string) {
  return {
    type: IDP_MEMBERSHIP_DOWNLOAD,
    request: {
      op: 'get',
      path: `/@membership-${downloadId}`,
    },
  };
}
